export enum SharedObjectType {
    Unknown = 0,
    Job = 1,
    Person = 2,
    Team = 3,
    TeamDiscoverySession = 4,
    Survey = 5
}
